module.exports = __webpack_public_path__ + "img/bookmark.feb99f66.svg";